import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Badge
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import moment from 'moment';
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { pdfHeader, pdfFooter, pdfTableStyles } from "../../../../pdfUtils";

function EstadoCuentaClientes() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ESTADO_CUENTA = process.env.REACT_APP_URL_ESTADO_CUENTA;
  const URL_CARGOS = process.env.REACT_APP_URL_CARGOS;
  const [t, i18n] = useTranslation("global");
  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-30);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [mailTo, setMailTo] = useState("");
  const [nombreCliente, setNombreCliente] = useState([]);
  const [saldo, setSaldo] = useState(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [modalMail2, setModalMail2] = useState(false);
  const toggleMail2 = () => setModalMail2(!modalMail2);

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [modalCargos, setModalCargos] = useState(false);
  const toggleCargos = () => setModalCargos(!modalCargos);
  const [modalRelacionado, setModalRelacionado] = useState(false);
  const toggleRelacionado = () => setModalRelacionado(!modalRelacionado);
  const [saldoFiltroRel, setSaldoFiltroRel] = useState("Pendientes");

  const [activo, setActivo] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [movimientos, setMovimientos] = useState([])
  const [idCliente, setIdCliente] = useState("");
  const [saldoInicial, setSaldoInicial] = useState(0);

  const [cargos, setCargos] = useState([]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    if (user.clientes) 
      axios
    .get(`${URL_CLIENTES}/${user.clientes}`, {
      headers: {
        Authorization:`Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allClientes = [response.data];
      // Array para pagination
      let arrayTabla = allClientes
        // .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
        .map((a) => {
            return {
              _id: a._id,
              activo: a.is_active,
              nombre_comercial: a.nombre_comercial,
              razon_social: a.razon_social,
              cargos: parseFloat(a.cargos),
              abonos: parseFloat(a.abonos),
              saldo: parseFloat(a.saldo),
              cliente:  a.nombre_comercial,
            }
        })
        .filter(function (el) {
          return el != null;
        });

      let dataFinal = Object.values(arrayTabla);

      setClientes(allClientes);
      setComments(dataFinal);
      //
    })
    .catch((err) => {
      console.log(err);
    });
  
     
      let SI = movimientos.map((c)=>{
        if(selectedFechaInicio){
          if(
          (selectedFechaInicio == "" || selectedFechaInicio > c.fecha)){
            return (
                c.cargo - c.abono
            )
          }
        }
        else{
          return 0
        }
      }).filter(function (el) {
        return el != null;
      });

      let TC = SI.reduce((t, total, index) => t + total, 0);

      setSaldoInicial(TC)

  }, [user, movimientos, selectedFechaInicio]);


  const ListaClientes = comments.sort((a, b) =>
    a.nombre_comercial > b.nombre_comercial ? 1 : -1
  );

  // function PDFTabla() {
  //   const data = ListaClientes.map((a) => {
  //     if (
  //       (activo == 0 || activo == a.is_active)
  //     ) {
  //       return [
  //         a.nombre_comercial,
  //         "$" + new Intl.NumberFormat("en-US").format(a.cargos),
  //         "$" + new Intl.NumberFormat("en-US").format(a.abonos),
  //         "$" + new Intl.NumberFormat("en-US").format(a.saldo),
  //       ];
  //     }
  //   });
  //   const dataPDF = Object.values(data);
  //   const dataPDFLimpia = dataPDF.filter(function (el) {
  //     return el != null;
  //   });
  //   const doc = new jsPDF("landscape");
  //   var img = new Image();
  //   img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
  //   doc.addImage(img, "png", 230, 30, 45, 15);
  //   var img2 = new Image();
  //   img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  //   doc.addImage(img2, "png", 140, 15, 25, 25);
  //   doc.text(`Estado de Cuenta`, 20, 40);
  //   doc.autoTable({
  //     head: [["Cliente", "Cargos", "Abonos", "Saldo"]],
  //     body: dataPDFLimpia,
  //     startY: 45,
  //     foot: [
  //       [
  //         "Totales",
  //         "$" + new Intl.NumberFormat("en-US").format(totalCargos),
  //         "$" + new Intl.NumberFormat("en-US").format(totalAbonos),
  //         "$" + new Intl.NumberFormat("en-US").format(totalSaldo),
  //       ],
  //     ],
  //     showFoot: "lastPage",
  //   });
  //   doc.save(`EstadosDeCuenta.pdf`);
  // }

  // function excel() {
  //   const dataExcel = ListaClientes.map((a) => {
  //     if (
  //       (activo == 0 || activo == a.is_active)
  //     ) {
  //       return {
  //         Cliente: a.nombre_comercial,
  //         Cargos: a.cargos,
  //         Abonos: a.abonos,
  //         Saldo: a.saldo
  //     }}
  //   });
  //   const dataExportExcel = Object.values(dataExcel);
  //   const dataExcelLimpia = dataExportExcel.filter(function (el) {
  //     return el != null;
  //   });

  //   var option = {};

  //   option.fileName = "EstadoCuenta";

  //   option.datas = [
  //     {
  //       sheetData: dataExcelLimpia,
  //       sheetName: "EstadoCuenta",
  //       sheetFilter: ["Cliente", "Cargos", "Abonos", "Saldo"],
  //       sheetHeader: ["Cliente", "Cargos", "Abonos", "Saldo"],
  //     },
  //   ];

  //   var toExcel = new ExportJsonExcel(option);
  //   toExcel.saveExcel();
  // }

  // function enviaMail() {
  //   const data = ListaClientes.map((a) => {
  //     if (
  //       (activo == 0 || activo == a.is_active)
  //     ) {
  //       return [
  //         a.nombre_comercial,
  //         "$" + new Intl.NumberFormat("en-US").format(a.cargos),
  //         "$" + new Intl.NumberFormat("en-US").format(a.abonos),
  //         "$" + new Intl.NumberFormat("en-US").format(a.saldo),
  //       ];
  //     }
  //   });
  //   const dataPDF = Object.values(data);
  //   const dataPDFLimpia = dataPDF.filter(function (el) {
  //     return el != null;
  //   });
  //   const doc = new jsPDF("landscape");
  //   var img = new Image();
  //   img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
  //   doc.addImage(img, "png", 230, 30, 45, 15);
  //   var img2 = new Image();
  //   img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  //   doc.addImage(img2, "png", 140, 15, 25, 25);
  //   doc.text(`Estado de Cuenta`, 20, 40);
  //   doc.autoTable({
  //     head: [["Cliente","Cargos", "Abonos", "Saldo"]],
  //     body: dataPDFLimpia,
  //     startY: 45,
  //     foot: [
  //       [
  //         "Totales",
  //         "$" + new Intl.NumberFormat("en-US").format(totalCargos),
  //         "$" + new Intl.NumberFormat("en-US").format(totalAbonos),
  //         "$" + new Intl.NumberFormat("en-US").format(totalSaldo),
  //       ],
  //     ],
  //     showFoot: "lastPage",
  //   });
  //   var att = doc.output("arraybuffer");
  //   var base64File = encode.encode(att, "base64");

  //   // Envia el Mail
  //   axios
  //     .post(
  //       URL_SEND_MAIL_ATT,
  //       {
  //         subject: "Estado de Cuenta",
  //         email: mailTo,
  //         fileName: "EstadoCuenta.pdf",
  //         att: base64File,
  //         text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
  //        <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
  //        <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
  //        <tbody>
  //        <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
  //        <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras los saldos de los clientes.</tr>
  //        </tbody>
  //        <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
  //        <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
  //        </table>`,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //         },
  //       }
  //     )
  //     .then(() => {
  //       toggleMail();
  //       Swal.fire("Good job!", "Enviado con exito", "success");
  //       setMailTo("")
  //     })
  //     .catch((error) => {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "Something went wrong!",
  //       });
  //       console.log(error);
  //     });
  // }



  const headers = [
    { name: `${t("Nombre Comercial")}`, field: "nombre_comercial", sortable: true },
    // { name: `${t("Cargos")}`, field: "cargos", sortable: true },
    // { name: `${t("Pagos")}`, field: "abonos", sortable: true },
    { name: `${t("Saldo")}`, field: "saldo", sortable: true },
    { name: `${t("Estado Cuenta")}`, field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.nombre_comercial
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          // comment.cargos.toString().includes(search)||
          // comment.abonos.toString().includes(search)||
          comment.saldo.toString().includes(search)
      );
    }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }

    setTotalItems(computedComments.length);

//Sorting comments
if (
  sorting.field &&
  // sorting.field != "cargos" &&
  // sorting.field != "abonos" &&
  sorting.field != "saldo"
) {
  const reversed = sorting.order === "asc" ? 1 : -1;
  computedComments = computedComments.sort(
    (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
  );
}

if (
  sorting.field &&
  sorting.order === "asc" &&
  (
    // sorting.field == "cargos" ||
    // sorting.field == "abonos" ||
    sorting.field == "saldo")
) {
  computedComments = computedComments.sort((a, b) =>
    parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
  );
}

if (
  sorting.field &&
  sorting.order === "desc" &&
  (
  //   sorting.field == "cargos" ||
  // sorting.field == "abonos" ||
    sorting.field == "saldo")
) {
  computedComments = computedComments.sort((a, b) =>
    parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
  );
}

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    activo,
  ]);

 async function jalaMov(id, cliente, saldo){
    await  axios
      .get(`${URL_ESTADO_CUENTA}/${id}`, {
        headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allVentas = response.data
      setMovimientos(allVentas);
      //
    })
    .catch((err) => {
      console.log(err);
    });
      setNombreCliente(cliente)
      setIdCliente(id)
      setSaldo(saldo)
      toggle()
  }

  async function jalaCargos(id, cliente, saldo){
    await  axios
      .get(`${URL_CARGOS}/cliente/${id}`, {
        headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allVentas = response.data
      setCargos(allVentas);
      //
    })
    .catch((err) => {
      console.log(err);
    });
      setNombreCliente(cliente)
      setIdCliente(id)
      setSaldo(saldo)
      toggleCargos()
  }

  // PDF Mail Excel Cliente
    let saldoParcial = saldoInicial
    let totalCargosEdoCte = 0
    let totalAbonosEdoCte = 0
    let totalSaldoEdoCte = 0

  function PDFOC() {
    let saldoParcial = saldoInicial
    let totalCargosEdoCte = 0
    let totalAbonosEdoCte = 0
    let totalSaldoEdoCte = 0
    const data = movimientos
      .map((a) => {
        if(
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)){
          totalCargosEdoCte = totalCargosEdoCte + a.cargo
          totalAbonosEdoCte = totalAbonosEdoCte + a.abono
          totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdo
          saldoParcial = saldoParcial + a.cargo - a.abono
      const cargos = "$" + new Intl.NumberFormat("en-US").format(a.cargo);
      const abonos = "$" + new Intl.NumberFormat("en-US").format(a.abono);
      var saldoParcialFormato = "$" + new Intl.NumberFormat("en-US").format(saldoParcial);
      return [a.fecha, a.movimiento, cargos, abonos, saldoParcialFormato];
    }
  })
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    const startY = pdfHeader(doc, "Estado de Cuenta", `Cliente ${nombreCliente}`);
    doc.autoTable({
      ...pdfTableStyles(),
      columnStyles: { 2: { halign: "right" }, 3: { halign: "right" }, 4: { halign: "right" } },
      head: [["Fecha", "Movimiento", "Cargos", "Abonos", "Saldo"]],
      body: dataPDFLimpia,
      startY,
      foot: [
        [
          "",
          "",
          { content: 'Saldo Anterior', colSpan: 2, styles: { halign: 'left' } },
          // "Saldo Anterior",
          "$" + new Intl.NumberFormat("en-US").format(saldoInicial),
        ],
        [
          "",
          "",
          { content: 'Cargos del Periodo', colSpan: 2, styles: { halign: 'left' } },
          "$" + new Intl.NumberFormat("en-US").format(totalCargosEdoCte),
        ],
        [
          "",
          "",
          { content: 'Abonos del Periodo', colSpan: 2, styles: { halign: 'left' } },
          "$" + new Intl.NumberFormat("en-US").format(totalAbonosEdoCte),
        ],
        [
          "",
          "",
          { content: 'Saldo Actual', colSpan: 2, styles: { halign: 'left' } },
          "$" + new Intl.NumberFormat("en-US").format(saldoParcial),
        ],
      ],
      showFoot: "lastPage",
    });
    pdfFooter(doc);
    doc.save(`EdoCtaCliente-${nombreCliente}.pdf`);
  }

  function emailFOC() {
    let saldoParcial = saldoInicial
    let totalCargosEdoCte = 0
    let totalAbonosEdoCte = 0
    let totalSaldoEdoCte = 0
    const data = movimientos
    .map((a) => {
      if(
      (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)){
        totalCargosEdoCte = totalCargosEdoCte + a.cargo
        totalAbonosEdoCte = totalAbonosEdoCte + a.abono
        totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdo
        saldoParcial = saldoParcial + a.cargo - a.abono
    const cargos = "$" + new Intl.NumberFormat("en-US").format(a.cargo);
    const abonos = "$" + new Intl.NumberFormat("en-US").format(a.abono);
    var saldoParcialFormato = "$" + new Intl.NumberFormat("en-US").format(saldoParcial);
    return [a.fecha, a.movimiento, cargos, abonos, saldoParcialFormato];
  }
})
  const dataPDF = Object.values(data);
  const dataPDFLimpia = dataPDF.filter(function (el) {
    return el != null;
  });
  const doc = new jsPDF();
  const startY = pdfHeader(doc, "Estado de Cuenta", `Cliente ${nombreCliente}  ·  Desde ${selectedFechaInicio}`);
  doc.autoTable({
    ...pdfTableStyles(),
    columnStyles: { 2: { halign: "right" }, 3: { halign: "right" }, 4: { halign: "right" } },
    head: [["Fecha", "Movimiento", "Cargos", "Abonos", "Saldo"]],
    body: dataPDFLimpia,
    startY,
    foot: [
      [
        "",
        "",
        { content: 'Saldo Anterior', colSpan: 2, styles: { halign: 'left' } },
        // "Saldo Anterior",
        "$" + new Intl.NumberFormat("en-US").format(saldoInicial),
      ],
      [
        "",
        "",
        { content: 'Cargos del Periodo', colSpan: 2, styles: { halign: 'left' } },
        "$" + new Intl.NumberFormat("en-US").format(totalCargosEdoCte),
      ],
      [
        "",
        "",
        { content: 'Abonos del Periodo', colSpan: 2, styles: { halign: 'left' } },
        "$" + new Intl.NumberFormat("en-US").format(totalAbonosEdoCte),
      ],
      [
        "",
        "",
        { content: 'Saldo Actual', colSpan: 2, styles: { halign: 'left' } },
        "$" + new Intl.NumberFormat("en-US").format(saldoParcial),
      ],
    ],
    showFoot: "lastPage",
  });
    pdfFooter(doc);
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Estado de Cuenta",
          email: mailTo,
          fileName: `EstadoCuenta-${nombreCliente}.pdf`,
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Estado de Cuenta de ${nombreCliente}.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail2();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setMailTo("")
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
  }

  function excelFOC() {
    const dataExcel = movimientos.map((a) => {
      if (
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
      ) {
        return {
          Fecha: a.fecha,
          Movimiento: a.movimiento,
          Numero: a.numero,
          Cargo: a.cargo,
          Abono: a.abono,
          Cargos: a.cargos,
      }}
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = `EdoCtaCliente-${nombreCliente}`;

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "EstadoCuenta",
        sheetFilter: ["Fecha", "Movimiento", "Numero", "Cargo", "Abono"] ,
        sheetHeader: ["Fecha", "Movimiento", "Numero", "Cargo", "Abono"] ,
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  async function jalaMovRel(id, cliente, saldo, email) {
    await axios
      .get(`${URL_ESTADO_CUENTA}Relacionado/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allVentas = response.data;
        setMovimientos(allVentas);
        //
      })
      .catch((err) => {
        console.log(err);
      });
    setNombreCliente(cliente);
    setIdCliente(id);
    setSaldo(saldo);
    setMailTo(email);
    toggleRelacionado();
  }

  function PDFOCRelacionado() {
    let saldoParcial = saldoInicial;
    let totalCargosEdoCte = 0;
    let totalAbonosEdoCte = 0;
    let totalSaldoEdoCte = 0;

    if(saldoFiltroRel == "Pendientes"){
      const data = movimientos
       .sort((a, b) => (a.referencia > b.referencia ? 1 : -1))
      .map((a) => {
        if (a.saldo > 1) {
          totalCargosEdoCte = totalCargosEdoCte + a.cargo;
          totalAbonosEdoCte = totalAbonosEdoCte + a.abono;
          totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdoCte;
          saldoParcial = saldoParcial + a.saldo;
          const cargos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.cargo);
          const abonos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.abono);
          var saldoParcialFormato =
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcial);
          return [
            a.fecha,
            a.referencia,
            a.customerFor,
            a.bl,
            a.contenedor,
            a.etd,
            a.eta,
            a.naviera,
            a.POL,
            a.POD,
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.cargo),
            // new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.abono),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.saldo),
            // new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcial),
          ];
        }
      });
      const dataPDF = Object.values(data);
      const dataPDFLimpia = dataPDF.filter(function (el) {
        return el != null;
      });
      const doc = new jsPDF("landscape");
      const startY = pdfHeader(doc, "Estado de Cuenta", `Cliente ${nombreCliente}`);
      doc.autoTable({
        ...pdfTableStyles(),
        columnStyles: { 10: { halign: "right" }, 11: { halign: "right" } },
        head: [
          [
            "Fecha",
            "Ref",
            "Customer For",
            "BL",
            "Container",
            "ETD",
            "ETA",
            "Shipping Line",
            "POL",
            "POD",
            "BILL",
            "TOTAL"
          ],
        ],
        body: dataPDFLimpia,
        startY,
        foot: [
          // [
          //   "",
          //   "",
          //   "",
          //   "",
          //   "",
          //   "",
          //   "",
          //   "",
          //   "",
          //   "",
          //   "Cargos",
          //   new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalCargosEdoCte),
          // ],
          // [
          //    "",
          //   "",
          //   "",
          //   "",
          //   "",
          //   "",
          //   "",
          //   "",
          //   "",
          //   "",
          //   "Abonos",
          //   new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalAbonosEdoCte),
          // ],
          [
             "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Saldo",
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcial),
          ],
        ],
        showFoot: "lastPage",
      });
      pdfFooter(doc);
      doc.save(`EdoCtaCliente-${nombreCliente}.pdf`);
    }else{
      const data = movimientos
       .sort((a, b) => (a.referencia > b.referencia ? 1 : -1))
      .map((a) => {
        if (
          (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
        ) {
          totalCargosEdoCte = totalCargosEdoCte + a.cargo;
          totalAbonosEdoCte = totalAbonosEdoCte + a.abono;
          totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdoCte;
          saldoParcial = saldoParcial + a.saldo;
          const cargos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.cargo);
          const abonos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.abono);
          var saldoParcialFormato =
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcial);
          return [
            a.fecha,
            a.referencia,
            a.customerFor,
            a.bl,
            a.contenedor,
            a.etd,
            a.eta,
            a.naviera,
            a.POL,
            a.POD,
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.cargo),
            // new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.abono),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.saldo),
            // new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcial),
          ];
        }
      });
      const dataPDF = Object.values(data);
      const dataPDFLimpia = dataPDF.filter(function (el) {
        return el != null;
      });
      const doc = new jsPDF("landscape");
      const startY = pdfHeader(doc, "Estado de Cuenta", `Cliente ${nombreCliente}`);
      doc.autoTable({
        ...pdfTableStyles(),
        columnStyles: { 10: { halign: "right" }, 11: { halign: "right" } },
        head: [
          [
           "Fecha",
            "Ref",
            "Customer For",
            "BL",
            "Container",
            "ETD",
            "ETA",
            "Shipping Line",
            "POL",
            "POD",
            "BILL",
            "TOTAL"
          ],
        ],
        body: dataPDFLimpia,
        startY,
        foot: [
          [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Cargos",
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalCargosEdoCte),
          ],
          [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Abonos",
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalAbonosEdoCte),
          ],
          [
           "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Saldo",
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcial),
          ],
        ],
        showFoot: "lastPage",
      });
      pdfFooter(doc);
      doc.save(`EdoCtaCliente-${nombreCliente}.pdf`);
    }
    



  }


  let totalCargos = 0
  let totalAbonos = 0
  let totalSaldo = 0

  let saldoParcialTabla = saldoInicial
  let totalCargosEdo = 0
  let totalAbonosEdo = 0
  let totalSaldoEdo = 0
 
  let totalCargos2 = 0
  let totalAbonos2 = 0
  let totalSaldo2 = 0

  let saldoParcialTablaRelacionado = 0;
  let totalCargosEdoRelacionado = 0;
  let totalAbonosEdoRelacionado = 0;

  return (
    <>
      <Header />
      {user.menuContenedoresClientes ? (
        <div className="card container col-sm-11">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <span className="page-title-icon"><i className="fas fa-file-invoice-dollar" /></span>
                {t("Estado de Cuenta")}
              </h3>
              <p className="page-subtitle">{t("Saldo de tu cuenta")}</p>
            </div>
            <div className="page-actions">
              {/* <Button
                size="sm"
                href="/MenuAdmin"
                className="btn btn-danger"
                id="botonListado"
              >
                 {t("Regresar")}
              </Button> */}
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  color="danger"
                  disabled
                  // onClick={PDFTabla}
                >
                  <i className="far fa-file-pdf" /> PDF
                </Button>
                <Button
                  size="sm"
                  disabled
                  // onClick={toggleMail}
                  color="info"
                >
                  <i className="fas fa-envelope" /> eMail
                </Button>
                <Button
                  size="sm"
                  color="primary"
                  disabled
                  // onClick={excel}
                >
                  <i className="far fa-file-excel" /> Excel
                </Button>
              </ButtonGroup>
            </div>
          </div>

          <div className="stats-row">
            <div className="stat-chip"><i className="fas fa-balance-scale" style={{ color: "#d97706" }} /> {t("Saldo")} <span>{"$" + new Intl.NumberFormat("en-US").format(commentsData.reduce((s, p) => s + p.saldo, 0))}</span></div>
          </div>
          <div>
            {/* <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div> */}
            {/* <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div> */}
          </div>
          {/* <Row>
            <Col md={2}>
              <Label>{t("Activo")}</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                required
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">{t("Selecciona")}</option>
                <option value="Si">{t("Activos")}</option>
                <option value="No">{t("Inactivos")}</option>
              </Input>
            </Col>
          </Row> */}
          <Table size="sm" hover className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((p) => {
                totalCargos = totalCargos + p.cargos
                totalAbonos = totalAbonos + p.abonos
                totalSaldo = totalSaldo + p.saldo
                {
                  return (
                    <tr>
                      <td className="td-strong"> {p.nombre_comercial}</td>
                      {/* <td>{"$"+new Intl.NumberFormat("en-US").format(p.cargos)}</td>
                      <td>{"$"+new Intl.NumberFormat("en-US").format(p.abonos)}</td> */}
                      <td className="td-num td-money">{"$"+new Intl.NumberFormat("en-US").format(p.saldo)}</td>
                      <td>
                     {/* <Button
                              color="info"
                              size="sm"
                              onClick={(e) => jalaMov(
                                  p._id, 
                                  p.cliente,
                                  p.saldo
                                )
                              }
                              id="Detalle"
                            >
                              <i class="fas fa-file-alt"></i>
                            </Button>
                             <Button
                              color="primary"
                              size="sm"
                              onClick={(e) => jalaCargos(p._id, p.cliente, p.saldo)}
                              // id="Detalle"
                            >
                              <i class="fas fa-file-alt"></i>
                            </Button> */}
                            <Button
                          color="primary"
                          size="sm"
                          onClick={(e) =>
                            jalaMovRel(p._id, p.cliente, p.saldo, p.email)
                          }
                          id="Detalle"
                          title={t("Estado de Cuenta")}
                        >
                          <i className="fas fa-eye"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                }
              })}
              {/* <tr>
                <td className="negrita" align="right">{t("Totales")}</td>
                <td className="negrita">{"$"+new Intl.NumberFormat("en-US").format(totalCargos)}</td>
                <td className="negrita">{"$"+new Intl.NumberFormat("en-US").format(totalAbonos)}</td>
                <td className="negrita">{"$"+new Intl.NumberFormat("en-US").format(totalSaldo)}</td>
                <td></td>
              </tr> */}
            </tbody>
          </Table>
          {/* <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div> */}
        </div>
      ) : undefined}
      <br />

      <Modal size="xxl" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Estado de Cuenta de {nombreCliente}</h4>
        </ModalHeader>
        <ModalBody>
          <div className="filter-bar">
            <div>
              <Label className="mr-sm-2">Fecha</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </div>
            <div className="page-actions">
              <ButtonGroup>
                <Button size="sm" color="danger"
                onClick={PDFOC}
                >
                  <i className="far fa-file-pdf" /> PDF
                </Button>
                <Button size="sm" color="info"
                onClick={toggleMail2}
                >
                  <i className="fas fa-envelope" /> eMail
                </Button>
                <Button
                  size="sm"
                  color="primary"
                  onClick={excelFOC}
                >
                  <i className="far fa-file-excel" /> Excel
                </Button>
              </ButtonGroup>
            </div>
          </div>
          <div className="stats-row">
            <div className="stat-chip"><i className="fas fa-balance-scale" style={{ color: "#dc2626" }} /> {t("Saldo")} <span>{"$" + new Intl.NumberFormat("en-US").format(saldo)}</span></div>
          </div>
          <div className="card container">
          <Table size="sm" hover className="table-responsive-xl">
                  <thead>
                      <tr align="center">
                        <th className="tituloTabla" align="left">
                          {t("Fecha")}
                        </th>
                        <th className="tituloTabla">
                          {t("Movimiento")}
                        </th>
                        <th className="tituloTabla">
                          {t("Numero")}
                        </th>
                        <th className="tituloTabla td-num">
                          {t("Cargos")}
                        </th><th className="tituloTabla td-num">
                          {t("Pagos")}
                        </th>
                        <th className="tituloTabla td-num">
                          {t("Saldo")}
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                        {selectedFechaInicio?(
                              <tr>
                              <td align="center" className="td-muted">NA</td>
                              <td align="center">{t("Saldo Anterior")}</td>
                              <td align="center" className="td-muted">NA</td>
                              <td className="td-num td-muted">NA</td>
                              <td className="td-num td-muted">NA</td>
                              <td className="td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(saldoInicial)}</td>
                            </tr>
                        ):undefined}
                      {movimientos
                      .map((c) => {
                        if(
                          (selectedFechaInicio == "" || selectedFechaInicio <= c.fecha)
                          ){
                        saldoParcialTabla = saldoParcialTabla + c.cargo - c.abono
                        totalCargosEdo = totalCargosEdo + c.cargo
                        totalAbonosEdo = totalAbonosEdo + c.abono
                        totalSaldoEdo = totalCargosEdo - totalAbonosEdo
                        return (
                          <tr>
                            <td align="center">{c.fecha}</td>
                           <td align="center">{c.movimiento}</td>
                           <td align="center" className="td-strong">{c.numero}</td>
                           <td className="td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(c.cargo)}</td>
                           <td className="td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(c.abono)}</td>
                           <td className="td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(saldoParcialTabla)}</td>
                         </tr>
                        )
                      }
                      })}

                      <tr className="total-row">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="negrita" >{t("Saldo Anterior")}</td>
                        <td className="negrita td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(saldoInicial)}</td>
                      </tr>

                      <tr className="total-row">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="negrita" >{t("Cargos del Periodo")}</td>
                        <td className="negrita td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(totalCargosEdo)}</td>
                      </tr>

                      <tr className="total-row">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="negrita" >{t("Pagos del Periodo")}</td>
                        <td className="negrita td-num td-money">{"$-" + new Intl.NumberFormat("en-US").format(totalAbonosEdo)}</td>
                      </tr>
                      <tr className="total-row">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="negrita" >{t("Saldo Actual")}</td>
                        <td className="negrita td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(saldoParcialTabla)}</td>
                      </tr>
                    </tbody>
                  </Table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            <i className="fas fa-times" /> {t("Cerrar")}
          </Button>
        </ModalFooter>
      </Modal>

      {/* <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>{t("Enviar Estado de Cuenta")}</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="info" onClick={enviaMail}>
               <i className="fas fa-paper-plane" /> {t("Enviar")}
              </Button>
            </ModalFooter>
          </Modal> */}
          <Modal size="sm" isOpen={modalMail2} toggle={toggleMail2}>
            <ModalHeader toggle={toggleMail2}>
              <h4>Enviar Estado de Cuenta</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="info" onClick={emailFOC}>
               <i className="fas fa-paper-plane" /> {t("Enviar")}
              </Button>
            </ModalFooter>
          </Modal>
          

{/* Estado de Cuenta 2 */}
<Modal size="xxl" isOpen={modalCargos} toggle={toggleCargos}>
        <ModalHeader toggle={toggleCargos}>
          <h4>Estado de Cuenta de {nombreCliente}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
          {/* <Col sm={3}>
            <ButtonGroup>
              <Button size="sm" className="btn" color="danger" 
              onClick={PDFOC}
              >
                PDF <i class="far fa-file-pdf"></i>
              </Button>
              <Button size="sm" className="btn" color="info" 
              onClick={toggleMail2}
              >
                eMail <i class="fas fa-at"></i>
              </Button>
              <Button
                size="sm"
                className="btn"
                color="primary"
                onClick={excelFOC}
              >
                Excel <i class="far fa-file-excel"></i>
              </Button>
            </ButtonGroup>
          </Col>  */}

                </Row>
          <div className="stats-row">
            <div className="stat-chip"><i className="fas fa-balance-scale" style={{ color: "#dc2626" }} /> Saldo <span>{"$" + new Intl.NumberFormat("en-US").format(saldo)}</span></div>
          </div>
          <div className="card container">
          <Table size="sm" hover className="table-responsive-xl">
                  <thead>
                      <tr align="center">
                        <th className="tituloTabla" align="left">
                          Fecha
                        </th>
                        <th className="tituloTabla">
                          Descripcion
                        </th>
                        <th className="tituloTabla td-num">
                          {t("Cargos")}
                        </th><th className="tituloTabla td-num">
                          {t("Pagos")}
                        </th>
                        <th className="tituloTabla td-num">
                          {t("Saldo")}
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      {cargos
                      .map((c) => {
                        totalCargos2 = totalCargos2 + c.cargos
                        totalAbonos2 = totalAbonos2 + c.abonos
                        totalSaldo2 = totalCargos2 - totalAbonos2
                        return (
                          <tr>
                            <td align="center">{c.fecha}</td>
                           <td align="center">{c.descripcion}</td>
                           <td className="td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(c.importe)}</td>
                           <td className="td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(c.abonos)}</td>
                           <td className="td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(c.saldo)}</td>
                         </tr>
                        )
                      })}

                      <tr className="total-row">
                        <td></td>
                        <td className="negrita" align="center">{t("Totales")}</td>
                        <td className="negrita td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(totalCargos)}</td>
                        <td className="negrita td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(totalAbonos)}</td>
                        <td className="negrita td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(totalSaldo)}</td>
                      </tr>

                    </tbody>
                  </Table>
          </div>
        </ModalBody>

        
        <ModalFooter>
          <Button color="secondary" onClick={toggleCargos}>
            <i className="fas fa-times" /> {t("Cerrar")}
          </Button>
        </ModalFooter>
      </Modal>


      <Modal size="xxl" isOpen={modalRelacionado} toggle={toggleRelacionado}>
        <ModalHeader toggle={toggleRelacionado}>
          <h4>Estado de Cuenta de {nombreCliente}</h4>
        </ModalHeader>
        <ModalBody>
          <div className="filter-bar">
            <div>
              <Label className="mr-sm-2">{t("Saldo")}</Label>
              <Input
                bsSize="sm"
                type="select"
                value={saldoFiltroRel}
                onChange={(e) => {
                  setSaldoFiltroRel(e.target.value);
                }}
              >
                <option value="Pendientes">{t("Pendientes")}</option>
                <option value="Todas">{t("Todas")}</option>
              </Input>
            </div>
            <div className="page-actions">
              <ButtonGroup>
                <Button
                  size="sm"
                  color="danger"
                  onClick={PDFOCRelacionado}
                >
                  <i className="far fa-file-pdf" /> PDF
                </Button>
              </ButtonGroup>
            </div>
          </div>

          <div className="stats-row">
            <div className="stat-chip"><i className="fas fa-balance-scale" style={{ color: "#dc2626" }} /> {t("Saldo")} <span>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldo)}</span></div>
          </div>

          <div>
            <Table size="xl" hover className="table-responsive-xl">
              <thead>
                <tr align="center">
                  <th className="tituloTabla" align="left">FECHA</th>
                  <th className="tituloTabla" align="left">REF/INV NO</th>
                  <th className="tituloTabla" align="left">CUSTOMER FOR</th>
                  <th className="tituloTabla" align="left">BL</th>
                  <th className="tituloTabla" align="left">CONTAINER</th>
                  <th className="tituloTabla" align="left">ETD</th>
                  <th className="tituloTabla" align="left">ETA</th>
                  <th className="tituloTabla" align="left">SHIPPING LINE</th>
                  <th className="tituloTabla" align="left">POL</th>
                  <th className="tituloTabla" align="left">POD</th>
                  <th className="tituloTabla td-num">BILL</th>
                  <th className="tituloTabla td-num">TOTAL</th>
                </tr>
              </thead>
              <tbody>
              {saldoFiltroRel == "Pendientes" ? (
                  <>
                {movimientos
                .sort((a, b) => (a.referencia > b.referencia ? 1 : -1))
                .map((c) => {
                  if (c.saldo > 1) {
                    saldoParcialTablaRelacionado = saldoParcialTablaRelacionado + c.saldo;
                    totalCargosEdoRelacionado = totalCargosEdoRelacionado + c.cargo;
                    totalAbonosEdoRelacionado = totalAbonosEdoRelacionado + c.abono;
                    // totalSaldoEdoRelacionado = totalCargosEdoRelacionado - totalAbonosEdoRelacionado;

                      return (
                        // <tr style={{backgroundColor:"#ed8c8c"}}>
                          <tr>
                          <td align="center">{c.fecha}</td>
                          <td align="center" className="td-strong">{c.referencia}</td>
                          <td align="center">{c.customerFor}</td>
                          <td align="center">{c.bl}</td>
                          <td align="center" className="td-strong">{c.contenedor}</td>
                          <td align="center">{c.etd}</td>
                          <td align="center">{c.eta}</td>
                          <td align="center">{c.naviera}</td>
                          <td align="center">{c.POL}</td>
                          <td align="center">{c.POD}</td>
                          <td className="td-num td-money">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(c.cargo)}
                          </td>
                          {/* <td align="right">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(c.abono)}
                          </td> */}
                          <td className="td-num td-money">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(
                                c.saldo
                              )}
                          </td>

                          {/* <td align="right">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(
                                saldoParcialTablaRelacionado
                              )}
                          </td> */}
                        </tr>
                      )
                  }}
                )}
                  </>

              ): (
                <>
              {movimientos
              .sort((a, b) => (a.referencia > b.referencia ? 1 : -1))
              .map((c) => { 
                  saldoParcialTablaRelacionado = saldoParcialTablaRelacionado + c.saldo;
                  totalCargosEdoRelacionado = totalCargosEdoRelacionado + c.cargo;
                  totalAbonosEdoRelacionado = totalAbonosEdoRelacionado + c.abono;
                  // totalSaldoEdoRelacionado = totalCargosEdoRelacionado - totalAbonosEdoRelacionado;

                    return (
                      // <tr style={{backgroundColor:"#ed8c8c"}}>
                        <tr>
                        <td align="center">{c.fecha}</td>
                          <td align="center" className="td-strong">{c.referencia}</td>
                          <td align="center">{c.customerFor}</td>
                          <td align="center">{c.bl}</td>
                          <td align="center" className="td-strong">{c.contenedor}</td>
                          <td align="center">{c.etd}</td>
                          <td align="center">{c.eta}</td>
                          <td align="center">{c.naviera}</td>
                          <td align="center">{c.POL}</td>
                          <td align="center">{c.POD}</td>
                          <td className="td-num td-money">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(c.cargo)}
                          </td>
                          {/* <td align="right">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(c.abono)}
                          </td> */}
                          <td className="td-num td-money">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(
                                c.saldo
                              )}
                          </td>

                          {/* <td align="right">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(
                                saldoParcialTablaRelacionado
                              )}
                          </td> */}
                      </tr>
                    )
                }
              )}
                </>

              )}

                {/* <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="negrita">
                    {t("Cargos")}
                  </td>
                  <td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalCargosEdoRelacionado)}
                  </td>
                </tr> */}

                {/* <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="negrita">
                    {t("Pagos")}
                  </td>
                  <td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US",{style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalAbonosEdoRelacionado)}
                  </td>
                </tr> */}
                <tr className="total-row">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="negrita">
                    {t("Saldo Actual")}
                  </td>
                  <td className="negrita td-num td-money">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcialTablaRelacionado)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleRelacionado}>
            <i className="fas fa-times" /> Cerrar
          </Button>
        </ModalFooter>
      </Modal>
      {loader}
    </>
  );
}

export default EstadoCuentaClientes;
